import { render } from "./PermissionComponent.vue?vue&type=template&id=32461d26&ts=true"
import script from "./PermissionComponent.vue?vue&type=script&lang=ts"
export * from "./PermissionComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__